import styled, { useTheme } from 'styled-components';
import { Tiles } from '@rebass/layout';
import AppBanner from '@/components/app-banner';
import Banner from '@/components/banner';
import Section from '@/components/section';
import SocialMediaProfiles from '@/components/social-media-profiles';
import { human } from '@/themes';
import { useTranslations } from 'next-intl';

// const AppBanner = dynamic(() => import('@/components/app-banner'), { ssr: false });

const Title = styled.div`
  ${human.header};
`;

const Subtitle = styled.div``;

const InnerContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 2em;
`;

const GridItem = styled.div`
  padding: 0 0.5em;
`;

const Contact = () => {
  const t = useTranslations('contact');
  const theme = useTheme();

  return (
    <>
      <Banner>
        <InnerContainer>
          <Title>{t('title')}</Title>
          <Subtitle>{t('subTitle')}</Subtitle>
        </InnerContainer>
      </Banner>
      <Section>
        <Tiles columns={[1, 3]}>
          <GridItem>
            <h4>{t('joinUs')}</h4>
            <SocialMediaProfiles
              justifyContent="center"
              angelList="https://angel.co/bidali"
              facebook="https://www.facebook.com/bidalihq"
              linkedin="https://www.linkedin.com/company/bidali"
              // telegram="https://t.me/bidali"
              twitter="https://twitter.com/bidalihq" />
          </GridItem>
          <GridItem>
            <h4>{t('support')}</h4>
            <p>{t('supportMessage')} <a href="mailto:support.spend@bidali.com" name="support.spend@bidali.com">support.spend@bidali.com</a></p>
          </GridItem>
          <GridItem>
            <h4>{t('general')}</h4>
            <p>{t('generalMessage')} <a href="mailto:hello@bidali.com" name="hello@bidali.com">hello@bidali.com</a></p>
          </GridItem>
        </Tiles>
      </Section>
      <AppBanner background={theme.colors.primary} inverted source="contact_us" />
    </>
  );
};

export async function getStaticProps ({ locale }) {
  return {
    props: {
      messages: require(`@/locales/${locale}.json`)
    }
  };
}

export default Contact;
